<template>
  <div class="ml10">
      <ul class="top_tab clearfix">
        <li class="fl" :class="{active:show=='configInfo'}" @click="tabToConfig">配置信息</li>
        <li class="fl" :class="{active:show=='fixedInfo'}" @click="tabToFixed">固定信息</li>
      </ul>
    <configInfo v-if="show=='configInfo'"></configInfo>
    <fixedInfo v-if="show=='fixedInfo'"></fixedInfo>
  </div>
</template>
<script>
  import configInfo from './pension_params/configInfo'
  import fixedInfo from './pension_params/fixedInfo'
  export default {
    name:'pensionParam',
    data () {
      return {
        show:'configInfo'
      }
    },
    components:{
      'configInfo': configInfo,
      'fixedInfo':fixedInfo
    },
    methods:{
      tabToConfig:function(){
        this.show = 'configInfo';
      },
      tabToFixed:function(){
        this.show = 'fixedInfo';
      }
    }
  }
</script>
<style lang="less">
  .top_tab{
    li{
      height:60px;
      line-height: 60px;
      padding:0 10px;
      text-align: center;
      font-size: 18px;
      margin-right: 10px;
      cursor: pointer;
    }
    li:hover{
      color: #00A5FA;
    }
    li.active{
      color: #00A5FA;
      border-bottom: 2px solid #00A5FA;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pensionParam.vue